// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreeDotMenu_headerDropdown__0WjEu {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
}

.ThreeDotMenu_dropdown__4Hz9n {
  display: inline-block;
  position: relative;
}

.ThreeDotMenu_dropdownToggle__cMDBB {
  cursor: pointer;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  color: #fff;
  font-size: 24px;
  background: none;
  border: none;
}

.ThreeDotMenu_dropdownToggle__cMDBB .ThreeDotMenu_material-icons__r4VIX {
  font-size: 32px; /* or 36px, 40px as needed */
  color: #000;     /* Optional: change icon color */
}

.ThreeDotMenu_dropdownMenu__SBm2j {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
  border-radius: 6px;
  min-width: 120px;
  z-index: 1000;
  padding: 8px 0;
  display: none;
}

.ThreeDotMenu_dropdownMenu__SBm2j.ThreeDotMenu_show__2xG5V {
  display: block;
}

.ThreeDotMenu_dropdownMenuItem__KiQUs a {
  display: block;
  padding: 8px 16px;
  text-decoration: none;
  color: #333;
  transition: background 0.2s;
}

.ThreeDotMenu_dropdownMenuItem__KiQUs a:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/ThreeDotMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe,EAAE,4BAA4B;EAC7C,WAAW,MAAM,gCAAgC;AACnD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".headerDropdown {\n  position: relative;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dropdown {\n  display: inline-block;\n  position: relative;\n}\n\n.dropdownToggle {\n  cursor: pointer;\n  padding: 10px;\n  display: inline-flex;\n  align-items: center;\n  color: #fff;\n  font-size: 24px;\n  background: none;\n  border: none;\n}\n\n.dropdownToggle .material-icons {\n  font-size: 32px; /* or 36px, 40px as needed */\n  color: #000;     /* Optional: change icon color */\n}\n\n.dropdownMenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: white;\n  box-shadow: 0px 4px 6px rgba(0,0,0,0.1);\n  border-radius: 6px;\n  min-width: 120px;\n  z-index: 1000;\n  padding: 8px 0;\n  display: none;\n}\n\n.dropdownMenu.show {\n  display: block;\n}\n\n.dropdownMenuItem a {\n  display: block;\n  padding: 8px 16px;\n  text-decoration: none;\n  color: #333;\n  transition: background 0.2s;\n}\n\n.dropdownMenuItem a:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerDropdown": `ThreeDotMenu_headerDropdown__0WjEu`,
	"dropdown": `ThreeDotMenu_dropdown__4Hz9n`,
	"dropdownToggle": `ThreeDotMenu_dropdownToggle__cMDBB`,
	"material-icons": `ThreeDotMenu_material-icons__r4VIX`,
	"dropdownMenu": `ThreeDotMenu_dropdownMenu__SBm2j`,
	"show": `ThreeDotMenu_show__2xG5V`,
	"dropdownMenuItem": `ThreeDotMenu_dropdownMenuItem__KiQUs`
};
export default ___CSS_LOADER_EXPORT___;
